import React from 'react'
import { Form } from 'antd'

/**
 * Mock `.fld-row` / `.fld-lbl`: the validation message is rendered at the right end of the label row
 * (not under the control). The outer no-style item re-renders on every store change so the label
 * follows `getFieldError`, the validators themselves are unchanged. Shared by the account forms
 * (Account details, Organizer details) inside an `.ac-form` grid (accountDetails.css).
 */
export default function AccountField({ name, label, rules, children, ...itemProps }) {
    return (
        <Form.Item noStyle shouldUpdate>
            {(form) => {
                const error = form.getFieldError(name)[0]
                return (
                    <Form.Item
                        name={name}
                        rules={rules}
                        className={error ? 'ac-field err' : 'ac-field'}
                        label={
                            <>
                                <span>{label}</span>
                                {error ? <span className="ac-req">{error}</span> : null}
                            </>
                        }
                        {...itemProps}
                    >
                        {children}
                    </Form.Item>
                )
            }}
        </Form.Item>
    )
}
